<div>
    <ng-container *ngIf="!ngControl.disabled">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <mat-form-field appearance="outline" floatLabel="always" style="width: 100%;">
            <mat-chip-grid #chipList> <!--style="height: fit-content!important;"-->
                <mat-chip-row *ngFor="let item of value"  (removed)="remove(item)">
                    {{item}}
                    <button matChipRemove>
                        <mat-icon style="margin-top: 6px;">cancel</mat-icon>
                    </button>
                </mat-chip-row>
                <input placeholder="Escriba aquí"
                       [matChipInputFor]="chipList"
                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                       [matChipInputAddOnBlur]="true"
                       (matChipInputTokenEnd)="add($event)">
            </mat-chip-grid>
        </mat-form-field>

        <!-- errors -->
        <ng-container *ngIf="ngControl.touched">
            <mat-error *ngIf="ngControl.hasError('required')">{{'INPUT.REQUIRED' | translate}}</mat-error>
            <mat-error *ngIf="ngControl.hasError('minlength')">{{'INPUT.MIN_LENGTH' | translate}}</mat-error>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="ngControl.disabled">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <mat-chip-grid>
            <mat-chip-row *ngFor="let item of value">{{item}}</mat-chip-row>
        </mat-chip-grid>
<!--        <p *ngFor="let item of value" style="font-weight: bold;">{{item}}</p>-->
    </ng-container>
</div>
